import { commonViewTexts } from '../common';

const targetName = commonViewTexts.blueprintData;

export const deleteModelImageDialogViewTexts = {
  title: targetName,
  message: [
    `選択された${targetName}を削除してよろしいですか？`,
    'この操作は取り消すことができず、登録し直すには再度画像をアップロードしアノテーションする必要があります。'
  ]
} as const;
